<template>
  <el-dialog
    :model-value="visible"
    title="新建文本素材"
    width="560px"
    :close-on-click-modal="false"
    @update:model-value="$emit('update:visible', $event)"
  >
    <el-form :model="form" label-width="80px" label-position="top">
      <el-form-item label="素材名称" required>
        <el-input v-model="form.name" placeholder="输入素材名称" maxlength="200" />
      </el-form-item>
      <el-form-item label="文本内容" required>
        <el-input
          v-model="form.textContent"
          type="textarea"
          :rows="10"
          placeholder="输入文本内容（最大 200KB）"
          maxlength="204800"
          show-word-limit
        />
      </el-form-item>
      <el-form-item label="描述">
        <el-input v-model="form.description" placeholder="简要描述" maxlength="1000" />
      </el-form-item>
      <el-form-item label="标签" v-if="tagList.length > 0">
        <el-select v-model="form.tagIds" multiple placeholder="选择标签" class="w-full" clearable>
          <el-option v-for="tag in tagList" :key="tag.id" :label="tag.name" :value="tag.id" />
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" :disabled="!form.name || !form.textContent" :loading="submitting" @click="handleSubmit">
        创建
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { createTextAsset } from '@/api/assets'

const props = defineProps({
  visible: { type: Boolean, default: false },
  folderId: { type: [Number, String], default: null },
  tagList: { type: Array, default: () => [] }
})

const emit = defineEmits(['update:visible', 'success'])

const form = reactive({
  name: '',
  textContent: '',
  description: '',
  tagIds: []
})
const submitting = ref(false)

async function handleSubmit() {
  submitting.value = true
  try {
    await createTextAsset({
      folderId: props.folderId,
      name: form.name,
      textContent: form.textContent,
      description: form.description || undefined,
      tagIds: form.tagIds?.length ? form.tagIds : undefined
    })
    ElMessage.success('文本素材创建成功')
    Object.assign(form, { name: '', textContent: '', description: '', tagIds: [] })
    emit('success')
  } catch {
    // handled by interceptor
  } finally {
    submitting.value = false
  }
}
</script>
